import type { Dispatch } from '@reduxjs/toolkit';
import useEffectOnce from '@rio-cloud/rio-uikit/useEffectOnce';

import { useAppDispatch } from '../../configuration/setup/hooks';
import { sendWindowMessage } from '../../services/sendWindowMessage';

const PREFIX = 'EVENT';

const receiveMessage = (event: MessageEvent, dispatch: Dispatch) => {
    const { type = '' } = event.data;

    if (!type.startsWith(PREFIX) || !dispatch) {
        return;
    }
};

export const useSetupWindowMessages = () => {
    const dispatch = useAppDispatch();

    // Register PostMessage event listener which takes a callback function to be executed when the child
    // triggers a defined remote action
    useEffectOnce(() => {
        const listenerCallback = (event: MessageEvent) => receiveMessage(event, dispatch);
        window.addEventListener('message', listenerCallback, false);
        return () => window.removeEventListener('message', listenerCallback, false);
    });

    // Send notification to livemonitor and get back initial state data
    // like if there is a charging station selected or not
    useEffectOnce(() => {
        sendWindowMessage({
            type: 'EVENT_WIDGET_LOADED',
        });
    });
};
